import React from 'react'
import { useTheme } from '@mui/material/styles'
import PropTypes from 'prop-types'
import { StyledTypography, PrefixContainer } from './components/index'

const OpsotTypography = ({
	variant = 'bodyMediumGrey',
	content,
	prefix = null,
	sx = {},
	children,
	component = null,
	...props
}) => {
	const theme = useTheme()

	return (
		<StyledTypography
			data-testid="opsot-typography"
			theme={theme}
			sx={sx}
			customVariant={variant}
			component={component || theme.typography[variant]?.element}
			{...props}
		>
			{prefix && <PrefixContainer theme={theme}>{prefix}</PrefixContainer>}
			{content}
			{children && children}
		</StyledTypography>
	)
}

export default OpsotTypography

OpsotTypography.propTypes = {
	/**
	 * Typography variant to use
	 */
	variant: PropTypes.oneOf([
		'desktopH1',
		'desktopH1Primary',
		'responsiveH1',
		'responsiveH1Primary',
		'desktopH2Primary',
		'responsiveH2Primary',
		'desktopH2White',
		'responsiveH2White',
		'desktopH3',
		'responsiveH3',
		'desktopH4',
		'responsiveH4',
		'desktopH5Black',
		'desktopH5White',
		'responsiveH5Black',
		'responsiveH5Primary',
		'bodySmall',
		'bodySmallPrimary',
		'bodySmallWhite',
		'bodySmallBlackUnderline',
		'bodyMediumPrimary',
		'bodyMediumWhite',
		'bodyMediumBlack',
		'bodyMediumBlackUnderline',
		'bodyMediumLink',
		'bodyMediumGrey',
		'bodyLargePrimary',
		'bodyLargeGrey',
		'bodyLargeBlack',
		'bodyLargeWhite',
		'searchResponse',
		'responsiveSearchResponse',
		'toolkitTitles',
		'filterSortHeadings',
		'filterSortOptions',
		'copyrightFooterText',
		'responsiveHeadline',
		'desktopHeadline',
		'bodyMediumLabel'
	]),
	/**
	 * The content to be displayed inside the Typography
	 */
	content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
	/**
	 * Prefix to display before the content
	 */
	prefix: PropTypes.node
}
